import React from 'react'
import { Row, Col, Button, Input, message, Switch } from 'antd';
import { withRouter } from "react-router-dom";
import CategoryEdit from './components/CategoryEdit'
import Editor from '../../../components/Editor'
import API from '@/api'
import Upload from './components/Upload'
import './index.less'

import { connect } from 'react-redux'
import { setUser, setCategories } from '@/store/actions'

const { TextArea } = Input;

@withRouter
@connect(
  state => ({
    user: state.user,
    route: state.route,
    categories: state.categories
  }),
  { setUser, setCategories }
)
class ArticleDetail extends React.Component {
  constructor (props) {
    super(props)

    this.DetailChild = React.createRef() // 此处初始化

    this.state = {
      contentMinHeight: 0,
      articleId: null,
      mainImageUrl: '',
      title: '',
      intro: '',
      detail: '',
      categories: [],
      openFlag: false
    }
  }

  async componentDidMount () {
    const { articleId } = this.props.match.params
    console.log('tt', articleId)
    this.setState({ articleId })
    if (articleId) {
      const res = await API.GetArticle({ article_id: articleId })
      if (res.code !== 200) return

      const { result } = res

      this.setState({
        mainImageUrl: result.main_image_url,
        title: result.title,
        intro: result.intro,
        detail: result.content,
        categories: result.categories,
        openFlag: result.open_flag ? true : false
      })

      this.DetailChild.current.initDetail(result.content)
    }
  }

  test1 = () => {
    // console.log(store.getState())
    console.log('setUser', this.props.setCategories([{ id: '123' }]))
  }

  test2 = () => {
    console.log('hasUser', this.props.categories)
  }

  categoryChange = cats => {
    this.setState({
      categories: cats
    })
  }

  changeInput = (key, e) => {
    this.setState({
      [key]: e.target.value
    })
  }

  changeSwitch = (key, e) => {
    this.setState({
      [key]: e
    })
  }

  detailChange = html => {
    this.setState({ detail: html })
  }

  saveArticle = async () => {
    const { articleId, mainImageUrl, title, intro, detail, categories, openFlag } = this.state

    if (!title) {
      message.warning('请输入标题')
      return
    }
    if (!detail) {
      message.warning('请输入内容')
      return
    }

    const articleObj = {
      article_id: articleId,
      main_image_url: mainImageUrl || null,
      title,
      intro: intro || null,
      content: detail,
      categories,
      open_flag: openFlag ? 1 : 0
    }
    const res = await API.SaveArticle(articleObj)
    if (res.code !== 200) return
    message.success('保存成功!')
  }

  delArticle = () => {
    console.log('delArticle')
  }

  uploadChange = (imageUrl) => {
    this.setState({ mainImageUrl: imageUrl })
  }

  render () {
    const { test1, test2, saveArticle, delArticle, changeInput, detailChange, categoryChange, uploadChange, changeSwitch } = this
    const { title, intro, detail, categories, articleId, mainImageUrl, openFlag } = this.state

    return (
      <div className="editor-container">
        <Row gutter={18}>
          <Col span={6}>
            <div className="editor-item editor-pic">
              <div className="label-title">大图 :</div>
              <Upload imageUrl={mainImageUrl} onChange={uploadChange} />
            </div>
            <div className="editor-item editor-title">
              <div className="label-title">标题 :</div>
              <TextArea size="large" value={title} onChange={e => changeInput('title', e)} rows={2} />
            </div>
            <div className="editor-item editor-intro">
              <div className="label-title">简述 :</div>
              <TextArea rows={6} value={intro} onChange={e => changeInput('intro', e)} />
            </div>
            <div className="editor-item editor-open">
              <Switch checkedChildren="开启" unCheckedChildren="关闭" checked={openFlag} onChange={e => changeSwitch('openFlag', e)} />
            </div>
            <div className="editor-item editor-category">
              <div className="label-title">分类 :</div>
              <CategoryEdit selectedArr={categories} onChange={categoryChange} />
            </div>
          </Col>
          <Col span={18}>
            <div className="editor-item editor-detail">
              <div className="label-title">详情 :</div>
              <div className="editor-detail-editor">
                <Editor ref={this.DetailChild} onChange={detailChange} />
              </div>
            </div>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: '18px' }}>
          <Col span={24}>
            <Button type="primary" onClick={saveArticle}>保存文章</Button>
            <Button type="danger" onClick={delArticle} style={{ marginLeft: '18px' }}>删除文章</Button>
            <Button type="default" onClick={test1} style={{ marginLeft: '18px' }}>测试1</Button>
            <Button type="default" onClick={test2} style={{ marginLeft: '18px' }}>测试2</Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ArticleDetail
